import styled, {css} from 'styled-components';

import {
  NewNumberInputField as BaseNewNumberInputField,
  NewSelectField as BaseNewSelectField,
  NewTextInputField as BaseNewTextInputField,
} from '@edna/components';
import {Label as BaseLabel} from '@edna/components/FormField/primitives';
import {Td as BaseTd, Th as BaseTh, Tr as BaseTr, getTableCellWidth} from '@edna/components/Table';
import {Row as BaseRow} from '@edna/components/primitives';
import {mixins} from '@edna/components/styles';

import {
  Badge as BaseBadge,
  CollapsibleSection as BaseCollapsibleSection,
  Subject as BaseSubject,
} from 'src/components';
import {Text as BaseText} from 'src/components/primitives';

export const Description = styled(BaseText)`
  ${({theme}) => css`
    color: ${theme.branding.content.secondary};
    margin: ${theme.spacing.s2} 0 0 ${theme.spacing.s5};
    white-space: pre-wrap;
  `}
`;

export const Subject = styled(BaseSubject)`
  margin-right: ${({theme}) => theme.spacing.s2};
`;

export const Badge = styled(BaseBadge)`
  width: max-content;
  margin-top: ${({theme}) => theme.spacing.s2};
`;

export const ModalRow = styled(BaseRow)`
  ${mixins.flexAlign('space-between', 'flex-end')}
  ${({theme}) => css`
    gap: ${theme.spacing.s4};
    margin-bottom: ${theme.spacing.s4};
  `}
`;

export const Label = styled(BaseLabel)`
  ${mixins.f2}
`;

export const MinField = styled(BaseNewNumberInputField)`
  max-width: 142px;
  margin: 0;
`;

export const Currency = styled.div`
  max-height: max-content;
  margin-top: ${({theme}) => theme.spacing.s8};
`;

export const Row = styled(BaseRow)`
  gap: ${({theme}) => theme.spacing.s4};
  margin-bottom: ${({theme}) => theme.spacing.s4};
`;

export const CollapsibleSection = styled(BaseCollapsibleSection)`
  margin-top: ${({theme}) => theme.spacing.s4};
`;

export const NewNumberInputField = styled(BaseNewNumberInputField)`
  margin: 0;
`;

export const ScrolledContent = styled.div<{maxHeightPercent?: number}>`
  max-height: ${({maxHeightPercent = 60}) => maxHeightPercent}vh;
  overflow-y: auto;
`;

export const NewTextInputField = styled(BaseNewTextInputField)`
  margin-bottom: ${({theme}) => theme.spacing.s1};
`;

export const NewSelectField = styled(BaseNewSelectField)`
  margin-bottom: ${({theme}) => theme.spacing.s1};
`;

export const FieldSet = styled.fieldset`
  ${mixins.stack({size: '3'})};
  width: 100%;
  margin: 0;
  margin-bottom: ${({theme}) => theme.spacing.s3};
  padding: 0;
  border: none;
`;

const COLUMNS_WIDTH = ['32%', '17%', '17%', '17%', '17%'];

export const Th = styled(BaseTh)`
  ${getTableCellWidth(COLUMNS_WIDTH)}
`;

export const Td = styled(BaseTd)`
  ${getTableCellWidth(COLUMNS_WIDTH)}
  ${mixins.flexAlign('flex-start', 'center')}
  padding-top: 0;
  padding-bottom: 0;
`;

export const Tr = styled(BaseTr)`
  padding-top: ${({theme}) => theme.spacing.s2};
  border-bottom: none;
  ${mixins.flexAlign('normal', 'flex-start')}
`;
